import { render, staticRenderFns } from "./V2ConnectionRequestModal.vue?vue&type=template&id=7242afea&scoped=true&"
import script from "./V2ConnectionRequestModal.vue?vue&type=script&lang=js&"
export * from "./V2ConnectionRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./V2ConnectionRequestModal.vue?vue&type=style&index=0&id=7242afea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242afea",
  null
  
)

export default component.exports